import React, { useEffect } from "react";
import { convocatorias } from "../../json/convocatorias";
import { convocatoriaHistoricos } from "../../json/convocatorias";
import "./convocatoriashistorico.css";

const ConvocatoriasHistorico = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="container convocatoriashistorico-container">
      <div className='row'>
            <div className='col_12'>
                <div className='convocatoriashistorico_title'>
                    <h1>ConvocatoriasHistorico</h1>
                </div>
            </div>
        </div>
        <div className="row">          
          {convocatorias.map((item) => (            
            <div className="col-md-3">
              <div className="card">
                <div className="card-body">
                  <div className="sec_convocatoriashistorico">
                    <h5>{item.nombre} <p className="anio">{item.anio}</p></h5>
                  </div>
                  <hr className="hr-gob" />
                  <div className="row mt-2">
                    <div class="btn-group" role="group">
                      {item.formatos !== undefined ? (
                        item.formatos.map((formato) => (
                          <a
                            className={"btn btn-sm btn-" + formato.id}
                            href={formato.enlaceformato}
                            target={"_blank"}
                          >
                            {formato.nombreformato}
                          </a>
                        ))
                      ) : (
                        <>
                          <p className="doc">No se requieren formatos</p>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="btn-convocatoriashistorico">
                    <a
                      className="btn btn-info btn-md"
                      href={item.enlace}
                      target={"_blank"}
                    >
                      Ver ConvocatoriaHistorico
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}



        </div>  
        <div className='container'>
        <div className='row'>
            <div>
                <h3 className='title'>Información Histórica</h3>
                <hr className='hr-gob'/>
            </div>
                {
                convocatoriaHistoricos.map((item, index)=>(
                    <div key={ index } className='col-md-3 col-sm-6 col-12'>
                        <div className='card_container_historicos'>
                            <div className='card_anio'>
                                <h5>{ item.anio }</h5>
                                <h6>{ item.descripcion }</h6>
                                {
                                    item.trimestres.map((trim, index)=>(
                                        <div key={ index } className='card_trimestre'>
                                            <p>{ trim.trimestre } <span className="badge bg-secondary">
                                                <a href={ trim.url } target="_blank">.zip</a></span>
                                            </p> 
                                        </div>
                                ))
                                }
                            </div>
                        </div>
                    </div>
                    ))
                }
        </div>
    </div>      

        
      </div>
    </>
  );
};

export default ConvocatoriasHistorico;